module.exports = __webpack_public_path__ + "assets/navBg@2x.98e976ef13460208b2a75314e6025e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/level/navBg@2x.png
// module id = 443
// module chunks = 0